import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function ForbiddenPage() {
  const location = useLocation();
  const fromPath = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">403 Forbidden</p>
        <h1 className="mt-2 text-2xl font-semibold text-slate-900">Access denied</h1>
        <p className="mt-3 text-sm text-slate-600">
          You are signed in, but this route requires permissions that are not present in your account scope.
        </p>

        {fromPath ? (
          <p className="mt-3 text-xs text-slate-500 break-all">
            Attempted route: <span className="font-mono">{fromPath}</span>
          </p>
        ) : null}

        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/dashboard"
            className="inline-flex items-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Go to dashboard
          </Link>
          <Link
            to="/campaigns"
            className="inline-flex items-center rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Open campaigns
          </Link>
        </div>
      </div>
    </div>
  );
}
